import { Navigate, Route, Routes } from "react-router-dom";

import { AdminShell } from "./components/AdminShell";
import { SiteShell } from "./components/SiteShell";
import {
  AdminContentPage,
  AdminDashboardPage,
  AdminLoginPage,
  AdminMessagesPage,
  AdminOrdersPage,
  AdminProductEditorPage,
  AdminProductsPage,
  ProtectedAdmin,
} from "./pages/AdminPages";
import { CartPage } from "./pages/CartPage";
import { HomePage } from "./pages/HomePage";
import {
  CheckoutCancelPage,
  CheckoutSuccessPage,
  ContactPage,
  NotFoundPage,
  PolicyPage,
} from "./pages/InfoPages";
import { ProductPage } from "./pages/ProductPage";
import { ShopPage } from "./pages/ShopPage";

export function App() {
  return (
    <Routes>
      <Route element={<SiteShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:categorySlug" element={<ShopPage />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/shipping" element={<PolicyPage kind="shipping" />} />
        <Route path="/returns" element={<PolicyPage kind="returns" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdmin>
            <AdminShell />
          </ProtectedAdmin>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="products/new" element={<AdminProductEditorPage />} />
        <Route path="products/:productId" element={<AdminProductEditorPage />} />
        <Route path="orders" element={<AdminOrdersPage />} />
        <Route path="content" element={<AdminContentPage />} />
        <Route path="messages" element={<AdminMessagesPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}

